import { Routes } from '@angular/router';

import { getFeatureToggle } from '../shared/feature-toggle';
import { MainNeighborInviteRegisterComponent } from './containers/main-neighbor-invite-register/main-neighbor-invite-register.component';
import { NeighborInviteRegisterComponent } from './neighbor-invite-register.component';

export const neighborInviteRegisterRoute: Routes = [
  {
    path: 'neighbor-invite-register/:inviteId',
    component: MainNeighborInviteRegisterComponent,
    canMatch: [(): boolean => getFeatureToggle().neighborInviteRegisterV2],
  },
  {
    path: 'neighbor-invite-register/:inviteId',
    component: NeighborInviteRegisterComponent,
  },
];
